export default "__VITE_ASSET__BNbNLaEa__"